import React, { useState, useEffect } from "react";
import { Input } from "antd";
import { SearchOutlined, MoreOutlined } from "@ant-design/icons";
import { useHistory, useParams } from "react-router-dom";
import { Spin, PageHeader } from "antd";

import { Table } from "../../components";
import { getUrl, requests } from "../../globals/requests";
import {
  Container,
  SpaceBetween,
  TableContainer,
  TableButtonsContainer,
} from "./styles";
import { helpers } from "../../utils";
import { savingsColumns } from "./helpers";

function UserSavings(props) {
  const [savings, setSavings] = useState([]);
  const [savingsBuff, setSavingsBuff] = useState([]);

  const [loading, setLoading] = useState(false);
  const [buff, setBuff] = useState({});

  const history = useHistory();
  const user = history?.location?.state?.user;
  let { userId } = useParams();

  savingsColumns[savingsColumns.length - 1].render = (saving) => (
    <MoreOutlined
      style={{ fontSize: "20px" }}
      onClick={() => moreOptions(saving)}
    />
  );

  function moreOptions(saving) {
    history.push(`/dashboard/savings/${saving?._id}`);
  }

  useEffect(() => {
    async function getSavings() {
      try {
        const url = `${getUrl("users")}/${userId}/savings`;
        setLoading(true);
        const response = await requests.getWithAuth(url);
        setLoading(false);
        setSavings(response.data);
        setSavingsBuff(response.data);
      } catch (e) {
        setLoading(false);
        helpers.displayMessage(e);
      }
    }

    getSavings();
  }, [userId]);

  function filterSavings(e) {
    const searchValue = e.target.value;
    if (searchValue === "") {
      setSavings(savingsBuff);
      return;
    }

    if (buff[searchValue]) {
      setSavings(buff[searchValue]);
    } else {
      const filteredSavers = savings.filter((el) => {
        const inFirstName = el.userId.first_name
          .toLowerCase()
          .includes(searchValue.toLowerCase());
        const inLastName = el.userId.last_name
          .toLowerCase()
          .includes(searchValue.toLowerCase());
        const inPlanName = el.name
          .toLowerCase()
          .includes(searchValue.toLowerCase());

        const inPlanType = el.type
          .toLowerCase()
          .includes(searchValue.toLowerCase());
        return inFirstName || inLastName || inPlanName || inPlanType;
      });
      setSavings(filteredSavers);
      setBuff({ ...buff, [searchValue]: filteredSavers });
    }
  }

  if (loading) {
    return (
      <div className="spin-contain">
        <Spin delay={100} size="large" tip="Getting Users..."></Spin>
      </div>
    );
  }

  return (
    <Container>
      <PageHeader
        className="site-page-header"
        onBack={() => history.goBack()}
        title="Back"
        subTitle={`${user.first_name + " " + user.last_name}'s Savings Plan`}
      />
      <TableButtonsContainer>
        <SpaceBetween>
          <div className="org-inpup-container">
            <Input
              size="large"
              onChange={filterSavings}
              placeholder="Search by name, plan or plan type"
              prefix={<SearchOutlined />}
            />
          </div>
        </SpaceBetween>
      </TableButtonsContainer>

      <TableContainer>
        <Table columns={savingsColumns} dataSource={savings} />
      </TableContainer>
    </Container>
  );
}

export default UserSavings;
